/**
 * Options d'ancrage calendaire partagées (mesures automatiques, tableaux).
 * `name` porte une clé transloco résolue par `ces-select-field`.
 */
export interface CalendarAnchorOption {
  id: number;
  name: string;
}

export const DAY_OF_WEEK_OPTIONS: CalendarAnchorOption[] = [
  { id: 1, name: 'common.weekdays.monday' },
  { id: 2, name: 'common.weekdays.tuesday' },
  { id: 3, name: 'common.weekdays.wednesday' },
  { id: 4, name: 'common.weekdays.thursday' },
  { id: 5, name: 'common.weekdays.friday' },
  { id: 6, name: 'common.weekdays.saturday' },
  { id: 7, name: 'common.weekdays.sunday' },
];

export const DAY_OF_MONTH_OPTIONS: CalendarAnchorOption[] = Array.from({ length: 31 }, (_, i) => ({
  id: i + 1,
  name: String(i + 1),
}));

export const MONTH_OPTIONS: CalendarAnchorOption[] = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  name: `common.months.${i + 1}`,
}));
